<div id="live-class-schedule" [formGroup]="schedulerForm" class="mt-8">
  <div class="flex items-center justify-between mb-4">
    <h4 class="text-2xl font-bold text-base-content">Schedule</h4>
    @if (isLocked) {
      <span class="daisy-badge daisy-badge-warning daisy-badge-sm gap-1 font-medium shrink-0">
        <i class="fa-solid fa-lock text-[10px]"></i> Locked
      </span>
    }
  </div>
  <div class="container">
    <div class="flex flex-wrap">
      <div class="w-full">
        @if (!isLocked) {
          <black-ui-modal>
            <button
              *blackModalTrigger="let toggle = toggle"
              (click)="toggle()"
              type="button"
              class="daisy-btn daisy-btn-primary mb-4 mt-2"
            >
              <i class="fa-solid fa-plus"></i> Add New Schedule
            </button>
          <div
            *blackModalContent="let close = close"
            class="reveal-modal fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60"
            (click)="close(); resetSchedulerForm()"
          >
            <div
              class="reveal-modal-body rounded-2xl bg-base-100 text-base-content border max-w-lg w-full p-6 shadow-2xl overflow-y-auto max-h-[90vh] relative"
              (click)="$event.stopPropagation()"
            >
              <button
                (click)="close(); resetSchedulerForm()"
                type="button"
                class="daisy-btn daisy-btn-sm daisy-btn-circle daisy-btn-ghost absolute right-4 top-4 text-base-content/70 hover:text-base-content"
              >
                <i class="fa-solid fa-xmark"></i>
              </button>
              <h3
                class="daisy-modal-title font-bold text-lg mb-4 text-base-content"
              >
                Add Schedule
              </h3>
              <div class="space-y-4">
                <div class="daisy-form-control w-full">
                  <label class="daisy-label">
                    <span
                      class="daisy-label-text font-semibold text-base-content"
                      >Title <span class="text-error">*</span></span
                    >
                  </label>
                  <input
                    type="text"
                    formControlName="title"
                    placeholder="Ex: Theory Session, Paper Discussion, etc."
                    class="daisy-input daisy-input-bordered w-full bg-base-100 text-base-content"
                  />
                  @if (
                    schedulerForm.controls.title.invalid &&
                    schedulerForm.controls.title.touched
                  ) {
                    <span class="text-error text-xs mt-1 font-medium"
                      >Schedule title is required</span
                    >
                  }
                </div>
                <div class="daisy-form-control w-full">
                  <label class="daisy-label">
                    <span
                      class="daisy-label-text font-semibold text-base-content"
                      >Repeat</span
                    >
                  </label>
                  <select
                    formControlName="repeat"
                    class="daisy-select daisy-select-bordered w-full bg-base-100 text-base-content"
                  >
                    <option value="ONCE" selected>Once</option>
                    <option value="DAILY">Daily</option>
                    <option value="WEEKLY">Weekly</option>
                    <option value="MONTHLY">Monthly</option>
                  </select>
                </div>

                @if (schedulerForm.controls.repeat.value === 'ONCE') {
                  <div class="daisy-form-control w-full">
                    <label class="daisy-label">
                      <span
                        class="daisy-label-text font-semibold text-base-content"
                        >Date</span
                      >
                    </label>
                    <input
                      formControlName="onceDate"
                      type="date"
                      class="daisy-input daisy-input-bordered w-full bg-base-100 text-base-content"
                    />
                  </div>
                }
                @if (schedulerForm.controls.repeat.value !== 'ONCE') {
                  <div class="daisy-form-control w-full">
                    <label class="daisy-label">
                      <span
                        class="daisy-label-text font-semibold text-base-content"
                        >Every</span
                      >
                    </label>
                    <div class="daisy-join w-full">
                      <input
                        class="daisy-input daisy-input-bordered daisy-join-item flex-1 bg-base-100 text-base-content"
                        formControlName="every"
                        type="number"
                        min="1"
                      />
                      <span
                        class="daisy-join-item daisy-btn daisy-btn-outline text-base-content"
                      >
                        {{ schedulerEveryText }}
                      </span>
                    </div>
                  </div>
                }
                @if (schedulerForm.controls.repeat.value === 'WEEKLY') {
                  <div class="daisy-form-control w-full">
                    <label class="daisy-label">
                      <span
                        class="daisy-label-text font-semibold text-base-content"
                        >Repeat on Days</span
                      >
                    </label>
                    <div class="daisy-divider my-1"></div>
                    <div
                      formGroupName="onTheWeek"
                      class="grid grid-cols-4 gap-2"
                    >
                      <label
                        class="daisy-label justify-start gap-2 cursor-pointer"
                      >
                        <input
                          id="Sunday"
                          formControlName="sunday"
                          type="checkbox"
                          class="daisy-checkbox daisy-checkbox-sm daisy-checkbox-primary"
                        />
                        <span class="daisy-label-text text-base-content"
                          >Sun</span
                        >
                      </label>
                      <label
                        class="daisy-label justify-start gap-2 cursor-pointer"
                      >
                        <input
                          id="Monday"
                          formControlName="monday"
                          type="checkbox"
                          class="daisy-checkbox daisy-checkbox-sm daisy-checkbox-primary"
                        />
                        <span class="daisy-label-text text-base-content"
                          >Mon</span
                        >
                      </label>
                      <label
                        class="daisy-label justify-start gap-2 cursor-pointer"
                      >
                        <input
                          id="Tuesday"
                          formControlName="tuesday"
                          type="checkbox"
                          class="daisy-checkbox daisy-checkbox-sm daisy-checkbox-primary"
                        />
                        <span class="daisy-label-text text-base-content"
                          >Tue</span
                        >
                      </label>
                      <label
                        class="daisy-label justify-start gap-2 cursor-pointer"
                      >
                        <input
                          id="Wednesday"
                          formControlName="wednesday"
                          type="checkbox"
                          class="daisy-checkbox daisy-checkbox-sm daisy-checkbox-primary"
                        />
                        <span class="daisy-label-text text-base-content"
                          >Wed</span
                        >
                      </label>
                      <label
                        class="daisy-label justify-start gap-2 cursor-pointer"
                      >
                        <input
                          id="Thursday"
                          formControlName="thursday"
                          type="checkbox"
                          class="daisy-checkbox daisy-checkbox-sm daisy-checkbox-primary"
                        />
                        <span class="daisy-label-text text-base-content"
                          >Thu</span
                        >
                      </label>
                      <label
                        class="daisy-label justify-start gap-2 cursor-pointer"
                      >
                        <input
                          id="Friday"
                          formControlName="friday"
                          type="checkbox"
                          class="daisy-checkbox daisy-checkbox-sm daisy-checkbox-primary"
                        />
                        <span class="daisy-label-text text-base-content"
                          >Fri</span
                        >
                      </label>
                      <label
                        class="daisy-label justify-start gap-2 cursor-pointer"
                      >
                        <input
                          id="Saturday"
                          formControlName="saturday"
                          type="checkbox"
                          class="daisy-checkbox daisy-checkbox-sm daisy-checkbox-primary"
                        />
                        <span class="daisy-label-text text-base-content"
                          >Sat</span
                        >
                      </label>
                    </div>
                  </div>
                }
                @if (schedulerForm.controls.repeat.value === 'MONTHLY') {
                  <div class="daisy-form-control w-full">
                    <label class="daisy-label">
                      <span
                        class="daisy-label-text font-semibold text-base-content"
                        >Repeat on the</span
                      >
                    </label>
                    <div class="space-y-3">
                      <div class="daisy-form-control">
                        <label class="daisy-label cursor-pointer">
                          <input
                            type="radio"
                            required
                            value="option-1"
                            formControlName="onTheMonthOption"
                            class="daisy-radio daisy-radio-sm daisy-radio-primary"
                          />

                          <select
                            formControlName="OnTheMonthDay"
                            class="daisy-select daisy-select-bordered daisy-select-sm w-full ml-2 bg-base-100 text-base-content"
                          >
                            @for (item of numberArrays(1, 31); track $index) {
                              <option>{{ item }}</option>
                            }
                          </select>
                        </label>
                      </div>
                      <div class="daisy-form-control">
                        <label class="daisy-label cursor-pointer">
                          <input
                            type="radio"
                            formControlName="onTheMonthOption"
                            value="option-2"
                            class="daisy-radio daisy-radio-sm daisy-radio-primary"
                          />
                          <select
                            formControlName="onTheMonthWeek"
                            class="daisy-select daisy-select-bordered daisy-select-sm w-28 mx-2 bg-base-100 text-base-content"
                          >
                            <option value="FIRST">First</option>
                            <option value="SECOND">Second</option>
                            <option value="THIRD">Third</option>
                            <option value="FOURTH">Fourth</option>
                            <option value="LAST">Last</option>
                          </select>
                          <select
                            formControlName="OnTheMonthWeekDay"
                            class="daisy-select daisy-select-bordered daisy-select-sm flex-1 bg-base-100 text-base-content"
                          >
                            <option>Monday</option>
                            <option>Tuesday</option>
                            <option>Wednesday</option>
                            <option>Thursday</option>
                            <option>Friday</option>
                            <option>Saturday</option>
                            <option>Sunday</option>
                          </select>
                        </label>
                      </div>
                    </div>
                  </div>
                }

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div class="daisy-form-control">
                    <label class="daisy-label">
                      <span
                        class="daisy-label-text font-semibold text-base-content"
                        >Start Time</span
                      >
                    </label>
                    <input
                      formControlName="from"
                      type="time"
                      class="daisy-input daisy-input-bordered w-full bg-base-100 text-base-content"
                    />
                  </div>
                  <div class="daisy-form-control">
                    <label class="daisy-label">
                      <span
                        class="daisy-label-text font-semibold text-base-content"
                        >Duration</span
                      >
                    </label>
                    <select
                      formControlName="duration"
                      class="daisy-select daisy-select-bordered w-full bg-base-100 text-base-content"
                    >
                      @for (opt of durationOptions; track opt.value) {
                        <option [value]="opt.value">{{ opt.label }}</option>
                      }
                    </select>
                    <div class="daisy-label">
                      <span class="daisy-label-text-alt text-base-content/60"
                        >Ends at {{ computedEndTime }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="daisy-form-control w-full">
                  <label class="daisy-label py-1">
                    <span
                      class="daisy-label-text font-semibold text-xs text-base-content"
                      >Direct Join Link (Optional)</span
                    >
                    <span
                      class="daisy-label-text-alt text-[10px] text-base-content/60"
                      >Zoom, Google Meet, MS Teams, etc.</span
                    >
                  </label>
                  <input
                    type="url"
                    formControlName="directJoinUrl"
                    placeholder="https://meet.google.com/abc-defg-hij"
                    class="daisy-input daisy-input-bordered daisy-input-sm w-full text-xs bg-base-100 text-base-content"
                  />
                </div>

                <div class="daisy-form-control w-full">
                  <label class="daisy-label py-1">
                    <span
                      class="daisy-label-text font-semibold text-xs text-base-content"
                      >Session Fee</span
                    >
                    <span
                      class="daisy-label-text-alt text-[10px] text-base-content/60"
                      >Override class fee for this session</span
                    >
                  </label>
                  <div class="grid grid-cols-3 gap-2 mb-2">
                    <label
                      class="daisy-label justify-start gap-2 cursor-pointer p-2 border rounded-lg hover:bg-base-200/50"
                    >
                      <input
                        type="radio"
                        value="DEFAULT"
                        formControlName="feeOption"
                        class="daisy-radio daisy-radio-sm daisy-radio-primary"
                      />
                      <span class="daisy-label-text text-xs text-base-content"
                        >Class Default</span
                      >
                    </label>
                    <label
                      class="daisy-label justify-start gap-2 cursor-pointer p-2 border rounded-lg hover:bg-base-200/50"
                    >
                      <input
                        type="radio"
                        value="FREE"
                        formControlName="feeOption"
                        class="daisy-radio daisy-radio-sm daisy-radio-success"
                      />
                      <span
                        class="daisy-label-text text-xs font-semibold text-success"
                        >Free Event</span
                      >
                    </label>
                    <label
                      class="daisy-label justify-start gap-2 cursor-pointer p-2 border rounded-lg hover:bg-base-200/50"
                    >
                      <input
                        type="radio"
                        value="CUSTOM"
                        formControlName="feeOption"
                        class="daisy-radio daisy-radio-sm daisy-radio-primary"
                      />
                      <span class="daisy-label-text text-xs text-base-content"
                        >Custom Fee</span
                      >
                    </label>
                  </div>
                  @if (schedulerForm.controls.feeOption.value === 'CUSTOM') {
                    <div class="daisy-join w-full mt-1">
                      <span
                        class="daisy-join-item daisy-btn daisy-btn-sm daisy-btn-outline no-animation pointer-events-none text-base-content/70"
                        >LKR</span
                      >
                      <input
                        type="number"
                        min="0"
                        formControlName="customPrice"
                        placeholder="Enter session fee"
                        class="daisy-input daisy-input-bordered daisy-input-sm daisy-join-item flex-1 bg-base-100 text-base-content"
                      />
                    </div>
                  }
                </div>

                <div class="daisy-modal-action mt-6">
                  <button
                    type="button"
                    (click)="close(); resetSchedulerForm()"
                    class="daisy-btn daisy-btn-ghost text-base-content/70"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    (click)="addToMeetingsSchedule(close)"
                    class="daisy-btn daisy-btn-primary"
                  >
                    <i class="fa-solid fa-plus"></i> Add to Schedule
                  </button>
                </div>
              </div>
            </div>
          </div>
        </black-ui-modal>
        } @else {
          <div class="daisy-alert daisy-alert-warning text-xs mb-4 mt-2">
            <i class="fa-solid fa-lock text-sm"></i>
            <span>Schedule is locked for published live classes to maintain timetable and calendar consistency for enrolled students.</span>
          </div>
        }
      </div>
      <div class="w-full">
        <div
          class="daisy-card daisy-card-bordered bg-base-100 text-base-content"
        >
          <div class="daisy-card-body p-5 sm:p-6">
            <h3 class="daisy-card-title text-lg mb-4 text-base-content">
              Scheduled Classes
            </h3>
            @for (schedule of meetingSchedules; track $index) {
              <div
                class="flex justify-between items-center rounded-xl bg-base-200 border p-4 mb-3 text-base-content"
              >
                <div class="flex-1">
                  <div class="flex items-center gap-2">
                    <h4 class="font-bold text-base-content">
                      {{ schedule.title }}
                    </h4>
                    @if (schedule.price === 0) {
                      <span
                        class="daisy-badge daisy-badge-sm daisy-badge-success font-bold"
                        >Free Event</span
                      >
                    } @else if (schedule.price !== null && schedule.price > 0) {
                      <span
                        class="daisy-badge daisy-badge-sm daisy-badge-primary font-bold"
                        >LKR {{ schedule.price | number }} / session</span
                      >
                    }
                  </div>
                  <p class="text-sm mt-1 text-base-content/70">
                    {{ fetchScheduleDescription(schedule) }}
                  </p>
                </div>
                @if (!isLocked) {
                  <button
                    (click)="removeMeetingsSchedule($index)"
                    type="button"
                    class="daisy-btn daisy-btn-sm daisy-btn-ghost text-error"
                  >
                    <i class="fa-solid fa-trash-alt"></i>
                  </button>
                }
              </div>
            } @empty {
              <div class="daisy-alert daisy-alert-warning text-sm">
                <i class="fa-solid fa-circle-info"></i>
                <span>No schedules yet. Add one to get started!</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
